import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { OrganizationService } from "@services";
import utils from "@utils";
import { Modal, ConfirmationModal } from "../../../../../components";
import "./EditSignupModal.scss";

const EditSignupModal = props => {
	const { lang } = global;
	const { organization, show, onHide, onSuccess } = props;
	const [form, setForm] = useState({ clientSignupUrl: organization.ClientSignupUrl });
	const _confirmationModal = useRef(null);

	useEffect(() => {
		setForm({ clientSignupUrl: organization.ClientSignupUrl });
	}, [organization]);

	const save = () => {
		if (!form.clientSignupUrl) {
			return;
		}

		OrganizationService.updateSignup(organization.Id, { ClientSignupURL: form.clientSignupUrl })
			.then(() => {
				onSuccess();
				utils.notify({
					type: "success",
					message: lang.t("Sing-up URL updated successfully"),
					timeOut: 1500,
				});
				setForm({ clientSignupUrl: "" });
				onHide();
			})
			.catch(({ response }) => {
				utils.notify({
					type: "error",
					message: response?.data?.Message ?? lang.t("Error updating sing-up URL"),
					title: "Error",
					timeout: 1500,
				});
			});
	};

	const confirmSaveModal = () => {
		_confirmationModal.current.openModal({
			title: lang.t("Edit Sign-up URL"),
			message: [
				<div className="text-center">
					{lang.t(
						"By editing this URL the previous version will no longer work, Are you sure you want to proceed_",
					)}
				</div>,
			],
			confirmButton: `${lang.t("Yes, Proceed")}`,
			onConfirm: () => save(),
			cancelButton: `${lang.t("No, Cancel")}`,
		});
	};

	const onInputChange = (field, value) => {
		if (!/^[0-9A-Za-z\\s-]+$/.test(value)) return;
		setForm({
			...form,
			[field]: value,
		});
	};

	return (
		<>
			<Modal
				id="edit-signup-modal"
				dialogClassName="edit-signup-dialog"
				size="xs"
				show={show}
				onHide={() => onHide()}
			>
				<Modal.Header
					closeButton
					className="hidden-print"
				>
					<Modal.Title>{lang.t("Edit Sign-up URL")}</Modal.Title>
				</Modal.Header>
				<Modal.Body className="container-fluid">
					<div className="row">
						<div className="col-xs-12">
							<label htmlFor="clientSignupUrl">{lang.t("Sign-up URL")}</label>
						</div>
						<div className="col-xs-12">
							<input
								className="form-control"
								id="clientSignupUrl"
								name="clientSignupUrl"
								value={form.clientSignupUrl}
								onChange={e => onInputChange("clientSignupUrl", e.target.value)}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						id="button-go-back"
						className="btn btn-link hidden-print"
						type="button"
						onClick={() => onHide()}
					>
						{lang.t("Close")}
					</button>
					<button
						type="button"
						id="save-signup"
						className="btn btn-primary"
						onClick={() => confirmSaveModal()}
						disabled={
							!form.clientSignupUrl ||
							form.clientSignupUrl === organization.ClientSignupUrl
						}
					>
						{`${lang.t("Save")}`}
					</button>
				</Modal.Footer>
			</Modal>
			<ConfirmationModal ref={_confirmationModal} />
		</>
	);
};

EditSignupModal.propTypes = {
	organization: PropTypes.object.isRequired,
	show: PropTypes.bool,
	onHide: PropTypes.func,
	onSuccess: PropTypes.func,
};

EditSignupModal.defaultProps = {
	show: false,
	onHide: () => {},
	onSuccess: () => {},
};

export default EditSignupModal;
